import { Grid, Paper } from "@mui/material";

import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import ThreeComponent from "../../../components/ThreeColumnsComponent";
import { IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE, IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO, IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE } from "../../../constants/signalRequestConsts";
import { getEmployeesInMyCharge, getEmployeesToApprove } from "../../../api/s10OrganizationApi";
import { searchInMyChargeEmployeesPaymentSlips, setInMyChargeEmployeePaymentSlipsReset } from "../../../store/slices/userRequests";
import TablePaymentSlips from "./TablePaymentSlips";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";

// viewType = All, InMyCharge, ToApprove

const EmployeesPaymentSlips = ({viewType}: {viewType: "All" | "InMyCharge" | "ToApprove"}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const timerThreeRef = useRef<NodeJS.Timeout | null>(null);

    const [rucSelected, setRucSelected] = useState<string>("")
    const [errorMsg, setErrorMsg] = useState<string>("")

    const [employeesCodes, setEmployeesCodes] = useState<string | null>(null)
    const [descriptionOne, setDescriptionOne] = useState<string>("")
    const [descriptionTwo, setDescriptionTwo] = useState<string>("")
    const [descriptionThree, setDescriptionThree] = useState<string>("")
    const [pageSizeOne, setPageSizeOne] = useState<number>(25)
    const [pageSizeTwo, setPageSizeTwo] = useState<number>(25)
    const [pageSizeThree, setPageSizeThree] = useState<number>(25)
    const [pageOne, setPageOne] = useState<number>(2)
    const [pageTwo, setPageTwo] = useState<number>(2)
    const [pageThree, setPageThree] = useState<number>(2)
    
    
    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || !connectionId) {
            return;
        }
        getInitialTablesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, connectionId]);

    
    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableOneRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionOne, pageSizeOne, pageOne, employeesCodes]);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableTwoRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionTwo, pageSizeTwo, pageTwo, employeesCodes]);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        if (timerThreeRef.current) {
            clearTimeout(timerThreeRef.current);
        }
        timerThreeRef.current = setTimeout(() => {
            tableThreeRequest();
        }, 500);
        return () => {
            if (timerThreeRef.current) {
                clearTimeout(timerThreeRef.current);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionThree, pageSizeThree, pageThree, employeesCodes]);
    
    const getInitialTablesData = async () => {

        let _employeesCodes =  "";
        dispatch(setInMyChargeEmployeePaymentSlipsReset(IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE));
        dispatch(setInMyChargeEmployeePaymentSlipsReset(IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO));
        dispatch(setInMyChargeEmployeePaymentSlipsReset(IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE));
        setEmployeesCodes(null);
        const finalRuc = rucSelected === "all" ? "" : rucSelected;
        if (viewType === "InMyCharge") {
            const result = await getEmployeesInMyCharge(finalRuc);
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado en el organigrama");
                return;
            }
            _employeesCodes = result?.data.join(",")
        } else if (viewType === "ToApprove") {
            const result = await getEmployeesToApprove();
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado a tu grupo de aprobacion")
                return;
            }
            _employeesCodes = result?.data.join(",")
        }
        setEmployeesCodes(_employeesCodes);
    }

    const tableOneRequest = () => 
        dispatch(searchInMyChargeEmployeesPaymentSlips(
            IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE,
            rucSelected,
            employeesCodes as any,
            1,
            descriptionOne,
            pageSizeOne,
            pageOne,
        ));

    const tableTwoRequest = () => 
        dispatch(searchInMyChargeEmployeesPaymentSlips(
            IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO,
            rucSelected,
            employeesCodes as any,
            2,
            descriptionTwo,
            pageSizeTwo,
            pageTwo,
        ));

    const tableThreeRequest = () => 
        dispatch(searchInMyChargeEmployeesPaymentSlips(
            IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE,
            rucSelected,
            employeesCodes as any,
            0,
            descriptionThree,
            pageSizeThree,
            pageThree,
            
        ));

    const ComponentOne = useCallback(() => (
        <TablePaymentSlips 
            requestId={IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE}
            page={pageOne}
            setPage={setPageOne}
            description={descriptionOne}
            setDescription={setDescriptionOne}
            pageSize={pageSizeOne}
            setPageSize={setPageSizeOne}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);
    const ComponentTwo = useCallback(() => (
        <TablePaymentSlips
            requestId={IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO}
            // hiddenFilterOptions={true}
            page={pageTwo}
            setPage={setPageTwo}
            description={descriptionTwo}
            setDescription={setDescriptionTwo}
            pageSize={pageSizeTwo}
            setPageSize={setPageSizeTwo}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);
    const ComponentThree = useCallback(() => (
        <TablePaymentSlips
            requestId={IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE}
            page={pageThree}
            setPage={setPageThree}
            description={descriptionThree}
            setDescription={setDescriptionThree}
            pageSize={pageSizeThree}
            setPageSize={setPageSizeThree}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            <MySelectCompany
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={'all'}
            />
            <ThreeComponent
                tabsTitle={["No firmados", "Del presente año", "Historico"]}
                useTabsNameAsTitle={true}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Paper>
        {errorMsg && <MySnackbar
            msg={errorMsg}
            severity={"error"}
            open={!!errorMsg}
            onClose={() => {
                setErrorMsg("");
            }}
        />}
    </Grid>)
}

export default EmployeesPaymentSlips;